<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <span slot="header">搜索</span>

      <el-button type="primary"
                 size="mini"
                 @click="onUploadFile(249)">导出当前提现金额
      </el-button>
      <el-button type="primary"
                 size="mini"
                 @click="onUploadFile(250)">导出当前账户余额
      </el-button>
    </layout-panel>
    <layout-panel :show-header="false">
      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row
                style="width: 100%"
                @sort-change="sortChange">
        <el-table-column prop="userid"
                         label="用户ID"
                         sortable="custom">
          <template slot-scope="scope">
            <router-link :to="{ path: '/users/detail/info?userid='+scope.row.userid}">
            {{scope.row.userid}}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="realname"
                         label="姓名"></el-table-column>
        <el-table-column prop="balance"
                         label="可提现额度"
                         sortable="custom"></el-table-column>
        <el-table-column prop="frozenbalance"
                         label="冻结额度"
                         sortable="custom"></el-table-column>
        <el-table-column prop="totalwithdraw"
                         label="已提现额度"
                         sortable="custom"></el-table-column>
        <el-table-column prop="pointinfo.points"
                         label="零豆余额"></el-table-column>
        <el-table-column prop="pointinfo.frozenpoints"
                         label="冻结零豆"></el-table-column>
        <el-table-column prop="pointinfo.spendpoints"
                         label="已使用零豆"></el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="260">
          <template slot-scope="scope">
            <router-link :to="{ path: '/order/table?userid='+scope.row.userid}">
              <el-button size="mini"
              > 订单列表
              </el-button>
            </router-link>
            <router-link :to="{path: '/users/point?userid='+scope.row.userid}">
              <el-button type="primary"
                         size="mini"
              > 零豆明细
              </el-button>
            </router-link>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table'

export default {
  mixins: [table],
  data () {
    return {
      search: {
        sortOrder: 'desc',
        sortField: 'userid'
      },
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0,
      },
      exportHeader: [
        {
          key: 'userid',
          text: '用户ID',
        },
        {
          key: 'provincename',
          text: '省份',
        },
        {
          key: 'cityname',
          text: '城市',
        },
        {
          key: 'credit',
          text: '提现金额',
        },
        {
          key: 'updatetime',
          text: '提现日期',
        },
      ],
      exportHeaderBalance: [
        {
          key: 'userid',
          text: '用户ID',
        },
        {
          key: 'provincename',
          text: '省份',
        },
        {
          key: 'cityname',
          text: '城市',
        },
        {
          key: 'balance',
          text: '账户余额',
        },
        {
          key: 'date',
          text: '日期',
        },
      ],
      withdrawUserTotal: 0,
      userBalanceTotal: 0,
    }
  },
  computed: Vuex.mapState({}),
  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     *
     */
    getTableData (params) {
      return request.page('getUserAccountList', params)
    },
    sortChange (column, prop, order) {
      let sortBy = 'asc'
      if (column.order === 'descending') {
        sortBy = 'desc'
      }
      if (column.prop) {
        this.search.sortOrder = sortBy
        this.search.sortField = column.prop
      }
      this.onSearch()
    },
    onUploadFile (type) {
      let formData = new FormData()
      formData.append('collection_type', 1) // 用户管理
      formData.append('type', type) // 批量任务类型
      formData.append('file_type', 3) // 文件类型:上传excel

      request.common('exportCurrentWithdrawUser', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '数据较多，请到批量用户查看',
          type: 'success',
        })
        this.onSearch()
      })
    },
  },
}
</script>


<style lang="scss"
       scoped>
</style>



// WEBPACK FOOTER //
// src/views/users/pages/UsersAccountTable.vue